<template>
  <page-layout
    :breadcrumbs="breadcrumbs"
    :title="$t('pages.configuracion.configuracionTextos')"
  >
    <o-main-progress v-if="loading"/>
    <div v-else>
      <o-description-title class="text-xs-center mb-2">
        {{$t('pages.configuracion.modificarTextos')}}     
      </o-description-title>
      <v-card v-if="idiomas.length > 1">
        <v-container fluid>
          <v-layout>
            <v-flex>
              <v-select
                :label="$t('general.misc.idioma')"
                :items="idiomas"
                :value="idiomaSeleccionado"
                hide-details
                @input="cambiarIdioma($event)"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
      <v-expansion-panel 
        v-for="(seccion, indexSeccion) in secciones"
        :key="seccion + '-' + indexSeccion"
        expand 
        v-model="expanded[indexSeccion]"
        class="mb-2"
      >
        <v-expansion-panel-content>
          <v-icon slot="actions" color="primary">keyboard_arrow_down</v-icon>
          <div slot="header">
            <o-medium-title>{{seccionesName[indexSeccion]}}</o-medium-title>
          </div>
          <v-card>
            <v-container fluid class="pt-0">
              <v-layout row>
                <v-flex pr-2 xs3>
                  <o-select-todos
                    :textoTodos="$t('general.misc.todos')"
                    :label="$t('pages.configuracion.ambito')"
                    :items="ambitosSelect"
                    v-model="ambitosSeleccionados"
                    multiple
                    class="multipleSelect selectText"
                  />
                </v-flex>
                <v-flex pl-2>
                  <o-select-todos
                    :textoTodos="$t('general.misc.todos')"
                    :label="$t('pages.configuracion.modulo')"
                    :items="pasosSelect"
                    v-model="pasosSeleccionados"
                    multiple
                    class="multipleSelect selectText"
                  />
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex grow>
                  <v-data-table
                    :headers="headers"
                    :items="textosPorSeccionFiltered[indexSeccion].claves"
                    class="mb-2"
                    :pagination.sync="paginations[indexSeccion]"
                  >
                    <template #items="props">
                      <tr class="pointer" @click="selectAbierto(indexSeccion, props.item.clave)"
                        :class="clavesSeleccionadas[indexSeccion] === props.item.clave ? 'grey lighten-2': ''"
                      >
                        <td>
                            {{ props.item.descripcionTabla }}
                        </td>
                        <td>
                            {{ props.item.pasoTraducido }}
                        </td>
                        <td>
                            {{ props.item.ambitoTraducido }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-layout
                v-if="clavesSeleccionadas[indexSeccion] !== null"
                justify-center mt-3
              >
                <v-flex 
                  xs12 md12 lg10
                >
                  <v-layout column>
                    <span class="grey--text pl-2 pb-2">{{$t('pages.configuracion.textoDefecto')}}</span>
                    <v-card>
                      <v-container fluid>
                        <span 
                          class="grey--text" 
                          v-html="textosData[indexSeccion][clavesSeleccionadas[indexSeccion]].idiomas.find(x => x.codigoIdioma === idiomaSeleccionado).valorDefecto"
                        />
                      </v-container>
                    </v-card>
                  </v-layout>
                </v-flex>
              </v-layout>
              <o-description-title v-if="clavesSeleccionadas[indexSeccion] === null" class="text-xs-center mt-5">
                {{$t('pages.configuracion.seleccioneTexto')}}  
              </o-description-title>
              <div v-else>
                <v-layout v-if="secciones[indexSeccion] != 'Textos generales' || promocionSeleccionada == null" row wrap justify-center mt-4>
                  <v-flex xs12 md12 lg10>
                    <v-layout column>
                      <span class="grey--text pl-2">{{$t('pages.configuracion.textoActual')}}</span>
                      <div
                        v-show="textosData[indexSeccion][clavesSeleccionadas[indexSeccion]].editorAvanzado === 'avanzado'"
                      >
                        <trumbowyg
                          v-model="textosData[indexSeccion][clavesSeleccionadas[indexSeccion]].idiomas.find(x => x.codigoIdioma === idiomaSeleccionado).valorData"
                          :config="{
                            btns: [
                              ['viewHTML'],
                              ['undo', 'redo'], // Only supported in Blink browsers
                              ['formatting'],
                              ['strong', 'em', 'underline'],
                              ['superscript', 'subscript'],
                              ['link'],
                              ['insertImage'],
                              ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                              ['unorderedList', 'orderedList'],
                              ['horizontalRule'],
                              ['removeformat'],
                              ['fullscreen']
                            ]
                          }"
                          @input="volverPorDefecto = false"
                          :name="$t('pages.configuracion.textoActual')"
                          :placeholder="$t('pages.configuracion.introduzcaTexto')"
                          auto-grow
                        />
                      </div>
                      <div
                        v-show="textosData[indexSeccion][clavesSeleccionadas[indexSeccion]].editorAvanzado === 'simple'"
                      >
                        <trumbowyg
                          v-model="textosData[indexSeccion][clavesSeleccionadas[indexSeccion]].idiomas.find(x => x.codigoIdioma === idiomaSeleccionado).valorData"
                          :config="{
                            btns: [
                              ['undo', 'redo'], // Only supported in Blink browsers
                              ['bold', 'italic', 'underline']
                            ]
                          }"
                          :name="$t('pages.configuracion.textoActual')"
                          :placeholder="$t('pages.configuracion.introduzcaTexto')"
                          auto-grow
                          @input="volverPorDefecto = false"
                        />
                      </div>
                      <div
                        v-show="textosData[indexSeccion][clavesSeleccionadas[indexSeccion]].editorAvanzado === 'ninguno'"
                      >
                        <v-textarea
                          v-model="textosData[indexSeccion][clavesSeleccionadas[indexSeccion]].idiomas.find(x => x.codigoIdioma === idiomaSeleccionado).valorData"
                          @input="volverPorDefecto = false"
                          auto-grow
                        />
                      </div>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout v-else row wrap justify-center mt-4>
                  <v-flex xs12 md12 lg10>
                    <v-layout column>
                      <span class="grey--text pl-2">{{$t('pages.configuracion.textoActual')}}</span>
                      <div
                        v-show="textosData[indexSeccion][clavesSeleccionadas[indexSeccion]].editorAvanzado === 'avanzado'"
                      >
                        <trumbowyg
                          v-model="textosData[indexSeccion][clavesSeleccionadas[indexSeccion]].textosPromocion.find(x => x.codigoPromocion === promocionSeleccionada.codigo).idiomas.find(x => x.codigoIdioma === idiomaSeleccionado).valorData"
                          :config="{
                            btns: [
                              ['viewHTML'],
                              ['undo', 'redo'], // Only supported in Blink browsers
                              ['formatting'],
                              ['strong', 'em', 'underline'],
                              ['superscript', 'subscript'],
                              ['link'],
                              ['insertImage'],
                              ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                              ['unorderedList', 'orderedList'],
                              ['horizontalRule'],
                              ['removeformat'],
                              ['fullscreen']
                            ]
                          }"
                          @input="volverPorDefecto = false"
                          :name="$t('pages.configuracion.textoActual')"
                          :placeholder="$t('pages.configuracion.introduzcaTexto')"
                          auto-grow
                        />
                      </div>
                      <div
                        v-show="textosData[indexSeccion][clavesSeleccionadas[indexSeccion]].editorAvanzado === 'simple'"
                      >
                        <trumbowyg
                          v-model="textosData[indexSeccion][clavesSeleccionadas[indexSeccion]].textosPromocion.find(x => x.codigoPromocion === promocionSeleccionada.codigo).idiomas.find(x => x.codigoIdioma === idiomaSeleccionado).valorData"
                          :config="{
                            btns: [
                              ['undo', 'redo'], // Only supported in Blink browsers
                              ['bold', 'italic', 'underline']
                            ]
                          }"
                          @input="volverPorDefecto = false"
                          :name="$t('pages.configuracion.textoActual')"
                          :placeholder="$t('pages.configuracion.introduzcaTexto')"
                          auto-grow
                        />
                      </div>
                      <div
                        v-show="textosData[indexSeccion][clavesSeleccionadas[indexSeccion]].editorAvanzado === 'ninguno'"
                      >
                        <v-textarea
                          v-model="textosData[indexSeccion][clavesSeleccionadas[indexSeccion]].textosPromocion.find(x => x.codigoPromocion === promocionSeleccionada.codigo).idiomas.find(x => x.codigoIdioma === idiomaSeleccionado).valorData"
                          @input="volverPorDefecto = false"
                          auto-grow
                        />
                      </div>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout 
                  v-if="seccion === 'Textos generales' && textosData[indexSeccion][clavesSeleccionadas[indexSeccion]].paso !== 'otros'" 
                  row wrap justify-center
                >
                  <v-flex xs12 md12 lg10>
                    <v-autocomplete
                      :label="$t('reservas.comprador.promocion')"
                      :items="promocionesOrdenadas"
                      item-text="descripcion"
                      return-object
                      v-model="promocionSeleccionada"
                      :disabled="guardando[indexSeccion]"
                      clearable
                      @change="cambiarPromocion(indexSeccion, $event)"
                    >
                      <template
                        slot="item"
                        slot-scope="{ parent, item }"
                      >
                        <v-list-tile-content style="position:relative">
                          <v-layout 
                            v-if="esPrimeraPromocion(item)" 
                            align-start style="margin-bottom: 10px;"
                          >
                            <span 
                              style="position:absolute; top:0px;font-size:13px" 
                              class="primary--text text--darken-1"
                            >
                              <!-- eslint-disable-next-line -->
                              {{$t(item.enTexto ? 'pages.configuracion.promocionConfigurada' : 'pages.configuracion.sinPromocionConfigurada')}}
                            </span>
                          </v-layout>
                          <v-layout row align-center justify-space-between style="width:100%">
                            <v-list-tile-title v-html="item.descripcion"></v-list-tile-title>
                          </v-layout>
                          <div
                            v-if="esUltimaPromocionConTexto(item)" 
                            style="margin-top:5px;width:100%"
                          >
                            <v-divider
                              style="position:absolute;bottom:2px;width:100%;min-height:2px;" 
                              class="primary"
                            />
                          </div>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout justify-center pt-2 wrap>
                  <v-btn
                    v-if="clavesSeleccionadas[indexSeccion] !== null"
                    color="primary" large
                    :disabled="textosIgualesDefecto(indexSeccion, clavesSeleccionadas[indexSeccion]) || guardando[indexSeccion]"
                    @click="reiniciarTexto(indexSeccion, clavesSeleccionadas[indexSeccion])"
                  >
                    {{$t('pages.cambiaDefecto')}}
                  </v-btn>
                  <v-btn
                    large color="primary"
                    :disabled="disabledVolverDefecto(indexSeccion) || !textosCambiados[indexSeccion] || guardando[indexSeccion]"
                    :loading="guardando[indexSeccion]"
                    @click="guardarTexto(indexSeccion, clavesSeleccionadas[indexSeccion])"
                  >
                      {{$t('pages.guardarCambios')}}
                  </v-btn>
                </v-layout>
              </div>
            </v-container>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
    <v-fade-transition>
      <PopUpSeguro
        v-if="mostrarCambiarTexto"
        @aceptar="cambiarSelectTexto($event)"
        :titulo="$t('pages.configuracion.editarTexto')"
        :alerta="$t('pages.configuracion.perderCambios')"
        pregunta=""
        :descartar="$t('pages.configuracion.continuar')"
        :cancelar="$t('general.popUpSeguro.cancelar')"
      />
    </v-fade-transition>
  </page-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import PopUpSeguro from '@/components/generic/PopUpSeguro'

export default {
  components: {
    PopUpSeguro
  },
  data () {
    return {
      loading: true,
      guardando: [],
      expanded: [],
      textosData: [],
      clavesSeleccionadas: [],
      cambiadoData: [],
      selectActual: null,
      mostrarCambiarTexto: false,
      idiomaSeleccionado: null,
      mostrarCambiarIdioma: false,
      nuevoIdiomaSeleccionado: null,
      ambitosSeleccionados: [],
      pasosSeleccionados: [],
      paginations: [],
      promocionSeleccionada: null,
      volverPorDefecto: false
    }
  },
  mounted () {
    window.addEventListener('beforeunload', this.alertPreRefresh)
  },
  async created () {
    try {
      this.idiomaSeleccionado = this.getIdioma
      this.nuevoIdiomaSeleccionado = this.getIdioma
      await this.loadPromociones()
      await this.loadAllTextos()
      this.expanded = this.secciones.map(() => {
        return [false]
      })
      this.paginations = this.secciones.map((x, i) => {
        return {
          sortBy: 'descripcionTabla',
          rowsPerPage: i == 0 ? -1 : 10,
          descending: false
        }
      })
      this.textosData = this.textosPorSeccion.map(textoSeccion => {
        this.clavesSeleccionadas.push(null)
        let textosObj = {}
        textoSeccion.textos
          .sort((a, b) => b.idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).descripcion - a.idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).descripcion)
          .forEach(texto => {
            textosObj[texto.clave] = {
              ...texto,
              textosPromocion: texto.textosPromocion.map(t => {
                return { 
                  ...t,
                  idiomas: t.idiomas.map(x => {
                    return {
                      ...x,
                      valorData: x.valor
                    }
                  })
                }
              }),
              idiomas: texto.idiomas.map(x => {
                return {
                  ...x,
                  valorData: x.valor
                }
              })
            }
          })
        this.pasosSeleccionados = this.pasosSelect.map(x => x.value)
        this.ambitosSeleccionados = this.ambitosSelect.map(x => x.value)
        this.cambiadoData.push(false)
        this.guardando.push(false)
        return textosObj
      })
      this.loading = false
    } catch (error) {
      console.log(error)
      this.addAlert({texto: error.message, color: 'error'})
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.cambiado) {
      let respuesta = confirm(this.$t('general.misc.alertPreRefresh'))
      if (respuesta) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.alertPreRefresh)
  },
  computed: {
    ...mapGetters({
      promociones: 'promociones/getAll',
      textosStore: 'textos/getAll',
      textoTienePromocion: 'textos/textoTienePromocion',
      idioma: 'login/getIdioma'
    }),
    promocionesOrdenadas () {
      if (this.clavesSeleccionadas[1] == null) {
        return this.promociones.map(p => {
          return {
            ...p,
            enTexto: false
          }
        })
      } else {
        let promocionesEnTexto = this.promociones.filter(x => this.textoTienePromocion(this.clavesSeleccionadas[1], x.codigo))
        .map(p => {
          return {
            ...p,
            enTexto: true
          }
        })
        let promocionesSinTexto = this.promociones.filter(x => !this.textoTienePromocion(this.clavesSeleccionadas[1], x.codigo))
        .map(p => {
          return {
            ...p,
            enTexto: false
          }
        })
        return promocionesEnTexto.concat(promocionesSinTexto)
      }
    },
    headers () {
      return [
        {
          text: this.$t('general.misc.descripcion'),
          value: 'descripcionTabla',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('pages.configuracion.modulo'),
          value: 'pasoTraducido',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('pages.configuracion.ambito'),
          value: 'ambitoTraducido',
          align: 'left',
          sortable: true
        }
      ]
    },
    breadcrumbs () {
      return [
        {
          text: this.$t('pages.home'),
          exact: true,
          to: {name: 'home'}
        },
        {
          text: this.$t('pages.configuracion.configuracion'),
          exact: true,
          to: {name: 'configuracion'}
        },
        {
          text: this.$t('pages.configuracion.textosMinuscula'),
          disabled: true
        }
      ]
    },
    idiomas () {
      return this.getIdiomas.map(x => {
        return {
          value: x,
          text: this.$t('general.idiomas.' + x)
        }
      })
    },
    ambitosSelect () {
      return [
        {
          value: 'VTA',
          text: this.$t('pages.configuracion.VTA')
        },
        {
          value: 'ALQ',
          text: this.$t('pages.configuracion.ALQ')
        }
      ]
    },
    pasosSelect () {
      let pasos = this.textosStore.map(x => x.paso)
      pasos = _.uniq(pasos)
      return pasos.map(x => {
        return {
          value: x,
          text: this.getPasoTraducido(x)
        }
      })
    },
    secciones () {
      return _.uniqWith(this.textosStore, (x, y) => x.seccion === y.seccion).map(x => {
        return x.seccion
      }).sort((a, b) => {
        if (a === 'Modulos') {
          return -1
        } else if (a === 'Textos generales' && b === 'Textos de correos') {
          return -1
        } else {
          return 1
        }
      })
    },
    seccionesName () {
      return this.secciones.map(x => {
        if (x === 'Textos generales') {
          return this.$t('pages.configuracion.textosGenerales')
        } else if (x === 'Textos de correos'){
          return this.$t('pages.configuracion.textosCorreos')
        } else {
          return this.$t('pages.configuracion.textosModulos')
        }
      })
    },
    textosPorSeccion () {
      return this.secciones.map(x => {
        return {
          seccion: x,
          textos: this.textosStore.filter(obj => obj.seccion === x),
          claves: this.textosStore.filter(obj => obj.seccion === x).map(y => {
            return {
              clave: y.clave,
              descripcion: y.descripcion,
              idiomas: [...y.idiomas],
              descripcionTabla: y.idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).descripcion,
              paso: y.paso,
              ambito: y.ambito,
              ambitoTraducido: this.$t('pages.configuracion.' + y.ambito),
              pasoTraducido: this.getPasoTraducido(y.paso)
            }
          }).sort((a, b) => a.idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).descripcion.localeCompare(b.idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).descripcion))
        }
      })
    },
    textosPorSeccionFiltered () {
      return this.textosPorSeccion.map(x => {
        return {
          ...x,
          textos: x.textos.filter(y => {
            return this.pasosSeleccionados.some(p => p === y.paso) && (y.ambito === 'AMBOS' || this.ambitosSeleccionados.some(a => a === y.ambito))
          }),
          claves: x.claves.filter(y => {
            return this.pasosSeleccionados.some(p => p === y.paso) && (y.ambito === 'AMBOS' || this.ambitosSeleccionados.some(a => a === y.ambito))
          })
        }
      })
    },
    textosCambiados () {
      return this.clavesSeleccionadas.map((clave, index) => {
        if (clave === null) {
          return false
        } else {
          if (this.cambiadoData[index]) {
            return this.cambiadoData[index]
          }
          this.$set(this.cambiadoData, index, this.cambiadoData[index] || !this.textosIguales(index, clave))
          return this.cambiadoData[index]
        }
      })
    },
    cambiado () {
      return this.cambiadoData.some(x => x)
    }
  },
  methods: {
    ...mapActions({
      loadPromociones: 'promociones/loadAll',
      loadAllTextos: 'textos/loadAll',
      modificarTextos: 'textos/modificar',
      addAlert: 'alerts/add'
    }),
    alertPreRefresh (e) {
      if (this.cambiado) {
        let message = this.$t('general.misc.alertPreRefresh')
        e = e || window.event
        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = message
        }
        // For Safari
        return message
      }
    },
    disabledVolverDefecto (index) {
      if (this.secciones[index] != 'Textos generales' || this.promocionSeleccionada == null) {
        return false
      }
      const textoPromo = this.textosData[index][this.clavesSeleccionadas[index]].textosPromocion.find(x => x.codigoPromocion == this.promocionSeleccionada.codigo).idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado)
      return this.volverPorDefecto && textoPromo.id == null
    },
    getPasoTraducido (paso) {
      return this.$t('pages.configuracion.pasos.' + paso)
    },
    esPrimeraPromocion (promocion) {
      let indexPromoBuscar = this.promocionesOrdenadas.findIndex(x => x.codigo == promocion.codigo)
      let indexPrimeraSinTexto = this.promocionesOrdenadas.findIndex(x => !x.enTexto)
      return indexPromoBuscar === 0 || indexPromoBuscar === indexPrimeraSinTexto
    },
    esUltimaPromocionConTexto (promocion) {
      let indexPromoBuscar = this.promocionesOrdenadas.findIndex(x => x.codigo == promocion.codigo)
      let indexPrimeraSinTexto = this.promocionesOrdenadas.findIndex(x => !x.enTexto)
      return indexPrimeraSinTexto > 0 && indexPromoBuscar === indexPrimeraSinTexto - 1
    },
    async cambiarPromocion(indexSeccion, promocion) {
      if (promocion != null) {
        let texto = this.textosData[indexSeccion][this.clavesSeleccionadas[indexSeccion]].textosPromocion.find(x => x.codigoPromocion === promocion.codigo)
        if (texto == null) {
          texto = this.textosData[indexSeccion][this.clavesSeleccionadas[indexSeccion]]
          this.textosData[indexSeccion][this.clavesSeleccionadas[indexSeccion]].textosPromocion.push(
            {
              ambito: texto.ambito,
              clave: texto.clave,
              codigoPromocion: promocion.codigo,
              descripcion: texto.descripcion,
              editorAvanzado: texto.editorAvanzado,
              idiomas:  texto.idiomas.map(x => {
                return {
                  codigoIdioma: x.codigoIdioma,
                  descripcion: x.descripcion,
                  valor: x.valor,
                  valorData: x.valor,
                  valorDefecto: x.valorDefecto
                }
              }),
              paso: texto.paso,
              seccion: texto.seccion,
              valor: texto.valor,
              valorDefecto: texto.valorDefecto
            }
          )
        }
      }
      this.$nextTick(() => {        
        this.$set(this.cambiadoData, indexSeccion, false)
      })
    },
    cambiarIdioma (newVal) {
      if (this.textosCambiados.some(x => x)) {
        this.nuevoIdiomaSeleccionado = newVal
        this.mostrarCambiarIdioma = true
      } else {
        this.idiomaSeleccionado = newVal
      }
    },
    async cambiarSelectIdioma (cambiar) {
      if (cambiar) {
        this.idiomaSeleccionado = this.nuevoIdiomaSeleccionado
        this.cambiadoData = this.cambiadoData.map(() => false)
      } else {
        const idiomaActual = this.idiomaSeleccionado
        this.idiomaSeleccionado = null
        this.$nextTick(() => {
          this.idiomaSeleccionado = idiomaActual
        })
      }
      this.mostrarCambiarIdioma = false
    },
    async reiniciarTexto (index, clave) {
      if (this.promocionSeleccionada == null) {
        this.textosData[index][clave].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valorData = this.textosData[index][clave].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valorDefecto
      } else {
        if (this.secciones[index] == 'Textos generales') {
          this.textosData[index][clave].textosPromocion.find(x => x.codigoPromocion === this.promocionSeleccionada.codigo).idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valorData = this.textosData[index][clave].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valor
          this.$nextTick(() => {
            this.volverPorDefecto = true
          })
        } else {
          this.textosData[index][clave].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valorData = this.textosData[index][clave].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valorDefecto
        }
      }
    },
    textosIguales (index, clave) {
      if (this.promocionSeleccionada == null) {
        return this.textosData[index][clave].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valorData === this.textosData[index][clave].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valor
      } else {
        if (this.secciones[index] == 'Textos generales') {
          return this.textosData[index][clave].textosPromocion.find(x => x.codigoPromocion === this.promocionSeleccionada.codigo).idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valorData === this.textosData[index][clave].textosPromocion.find(x => x.codigoPromocion === this.promocionSeleccionada.codigo).idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valor
        } else {
          return this.textosData[index][clave].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valorData === this.textosData[index][clave].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valor
        }
      }      
    },
    textosIgualesDefecto (index, clave) {
      if (this.promocionSeleccionada == null) {
        return this.textosData[index][clave].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valorData === this.textosData[index][clave].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valorDefecto
      } else {
        if (this.secciones[index] == 'Textos generales') {
          return this.textosData[index][clave].textosPromocion.find(x => x.codigoPromocion === this.promocionSeleccionada.codigo).idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valorData === this.textosData[index][clave].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valor
        } else {
          return this.textosData[index][clave].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valorData === this.textosData[index][clave].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valorDefecto
        }
      }      
    },
    async guardarTexto (index, clave) {
      try {
        this.$set(this.guardando, index, true)
        let texto = null
        let codigoPromocion = null
        let volverPorDefectoAux = false
        let noEnviarTexto = false
        if (this.secciones[index] == 'Textos generales' && this.promocionSeleccionada != null) {
          texto = this.textosData[index][clave].textosPromocion.find(x => x.codigoPromocion == this.promocionSeleccionada.codigo).idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado)
          codigoPromocion = this.promocionSeleccionada.codigo
          volverPorDefectoAux = this.volverPorDefecto
          noEnviarTexto = this.volverPorDefecto && texto.id == null
        } else {
          texto = this.textosData[index][clave].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado)
        }
        if (!noEnviarTexto) {
          await this.modificarTextos(
            {
              idioma: this.idiomaSeleccionado,
              clave: clave,
              valor: texto.valorData,
              codigoPromocion: codigoPromocion,
              volverPorDefecto: volverPorDefectoAux
            }
          )
        }
        if (this.secciones[index] == 'Textos generales' && this.promocionSeleccionada != null) {
          const textosPromocionesGuardado = this.textosStore.find(x => x.clave === clave).textosPromocion.map(t => {
            return { 
              ...t,
              idiomas: t.idiomas.map(x => {
                return {
                  ...x,
                  valorData: x.valor
                }
              })
            }
          })
          this.textosData[index][clave].textosPromocion = textosPromocionesGuardado
          if (textosPromocionesGuardado.find(x => x.codigoPromocion === this.codigoPromocion) == null) {
            this.cambiarPromocion(index, this.promocionSeleccionada)
          }
        } else {
          this.textosData[index][clave].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valor = this.textosData[index][clave].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valorData
        }
        this.$set(this.cambiadoData, index, false)
        this.$set(this.guardando, index, false)
      } catch (error) {
        this.$set(this.guardando, index, false)
        this.addAlert({texto: error.message, color: 'error'})
      }
    },
    selectAbierto (index, value) {
      if (this.textosCambiados[index]) {
        this.selectActual = {
          index: index,
          value: value,
          textoObj: this.textosData[index][this.clavesSeleccionadas[index]]
        }
        this.mostrarCambiarTexto = true
      } else {
        if (this.secciones[index] == 'Textos generales') {
          this.promocionSeleccionada = null
          this.volverPorDefecto = false
        }
        this.$set(this.clavesSeleccionadas, index, value)
      }
    },
    async cambiarSelectTexto (cambiar) {
      const index = this.selectActual.index
      const value = this.selectActual.value
      if (cambiar) {
        this.textosData[index][this.clavesSeleccionadas[index]].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valorData = this.textosData[index][this.clavesSeleccionadas[index]].idiomas.find(x => x.codigoIdioma === this.idiomaSeleccionado).valor
        this.$set(this.clavesSeleccionadas, index, value)
        this.$set(this.cambiadoData, index, false)
        if (this.secciones[index] == 'Textos generales') {
          this.promocionSeleccionada = null
          this.volverPorDefecto = false
        }
      } else {
        const valorClave = this.textosData[index][this.clavesSeleccionadas[index]].clave
        this.$set(this.clavesSeleccionadas, index, null)
        this.$nextTick(() => {
          this.$set(this.clavesSeleccionadas, index, valorClave)
        })
      }
      this.mostrarCambiarTexto = false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/configuracion/configuracionTextos.vue